import ClientUtils from './utils';

const environment = process.env.NWEA_ENV || 'team16';

const baseUrl = !__BATCH__ ? '/gateway/api' : `https://reportinggateway.${environment}.map2.nweacolo.pvt/gateway/api`;

export default {
    getCombinedStudentInformation: (partnerBid, studentBid, callback, callbackFailure) => {
        let url;
        if (process.env.ROUTE_TO_MOCK_SERVER === 'true') {
            const mockBaseUrl = 'http://localhost:3001';
            url = `${mockBaseUrl}/combined/${studentBid}`;
        } else {
            url = `${baseUrl}/partners/${partnerBid}/students/${studentBid}/combined`;
        }
        return ClientUtils.makeGetRequest(url, callback, {}, callbackFailure, 60000);
    },
    getRitQuintiles: (requestPayload, callback, failureCallback) => {
        const url = `${baseUrl}/norms/rit/batch`;
        return ClientUtils.makePostRequest(url, callback, requestPayload, null, failureCallback);
    },
    districtAverages: (partnerBid, payload, callback, failureCallback) => {
        const url = `${baseUrl}/partners/${partnerBid}/district-averages`;

        return __DISABLE_DISTRICT_AVERAGES__
            ? () => callback([])
            : ClientUtils.makePostRequest(url, callback, payload, null, failureCallback);
    },
    getGrowthProjections: (payload, callback, failureCallback) => {
        const url = `${baseUrl}/norms/growth-projections`;

        return ClientUtils.makePostRequest(url, callback, payload, null, failureCallback);
    },
    getGrowthPercentiles: (payload, callback, failureCallback) => {
        const url = `${baseUrl}/norms/growth-percentiles`;

        return ClientUtils.makePostRequest(url, callback, payload, null, failureCallback);
    },
    growthPreview: (params, callback, failureCallback) => {
        const url = `${baseUrl}/norms/growth/preview`;

        return ClientUtils.makeGetRequest(url, callback, params, failureCallback);
    },
    statusPreview: (params, callback, failureCallback) => {
        const url = `${baseUrl}/norms/status/preview`;

        return ClientUtils.makeGetRequest(url, callback, params, failureCallback);
    },
    postGrowthGoal: (partner, student, goal, callback, failureCallback) => {
        const url = `${baseUrl}/partners/${partner}/students/${student}/goals`;

        return ClientUtils.makePostRequest(url, callback, goal, null, failureCallback);
    },
    putGrowthGoal: (goal, growthGoalBid, callback, failureCallback) => {
        const url = `${baseUrl}/goals/${growthGoalBid}`;

        return ClientUtils.makePutRequest(url, callback, goal, null, failureCallback);
    },
    deleteGrowthGoal: (growthGoalBid, callback, failureCallback) => {
        const url = `${baseUrl}/goals/${growthGoalBid}`;

        return ClientUtils.makeDeleteRequest(url, callback, null, failureCallback);
    },
    linkingStudiesForPartner: (partnerBid, callback, failureCallback) => {
        const url = `${baseUrl}/studies`;
        const params = { partner: partnerBid };
        return ClientUtils.makeGetRequest(url, callback, params, failureCallback);
    },
    postLinkingStudies: (payload, callback, failureCallback) => {
        let url;
        if (process.env.ROUTE_TO_MOCK_SERVER__postLinkingStudies === 'true') {
            const mockBaseUrl = 'http://localhost:3001';
            url = `${mockBaseUrl}/postLinkingStudies`;
        } else {
            url = `${baseUrl}/linking-studies`;
        }

        return ClientUtils.makePostRequest(url, callback, payload, null, failureCallback);
    },

    highlightsForStudent: (partnerBid, studentBid, callback, failureCallback) => {
        let url = baseUrl + '/partners/' + partnerBid + '/students/' + studentBid + '/highlights';

        if (process.env.HIGHLIGHTS_OFF === 'true' && window.location.hostname != 'localhost') {
            /**
             * Currently ORF01/team16 Env does not support highlights.
             * TODO: Options: Create mocks, leave empty or setup ORF01 with Cistern (for all data including highlights).
             */
            return { studentBid: studentBid, highlights: {} };
        }

        return ClientUtils.makeGetRequest(url, callback, null, failureCallback);
    },
};
